(() => {
  const dismissedKey = 'rt-review-popup-dismissed';
  const markDismissed = () => {
    document.documentElement.classList.add('rt-review-popup-dismissed');
    try { sessionStorage.setItem(dismissedKey, '1'); } catch (_) {}
  };
  try { if (sessionStorage.getItem(dismissedKey)) markDismissed(); } catch (_) {}
  document.addEventListener('click', (event) => {
    if (event.target.closest('.jdgm-popup-card__close-btn')) markDismissed();
  }, true);

  const init = () => {
    const footer = document.querySelector('m-footer, footer');
    if (footer) {
      new IntersectionObserver((entries) => {
        document.documentElement.classList.toggle('rt-footer-visible', entries[0].isIntersecting);
      }).observe(footer);
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
